import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	'pages/Resource/Planning/ResourcePlanningPage'
));

export default [{ component, exact: true, path: '/resource-planning-view' }];
